import type { SVGProps } from 'react';
const DawnFlagTN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-TN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-TN_svg__a)">
      <path fill="#E92434" d="M0 0h22v16H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M15.715 8c0 2.65-2.111 4.8-4.715 4.8S6.286 10.65 6.286 8 8.396 3.2 11 3.2s4.715 2.149 4.715 4.8M9.429 8c0-1.773 1.307-3.235 2.995-3.442A3.6 3.6 0 0 0 11 4.267C8.975 4.267 7.334 5.938 7.334 8S8.975 11.733 11 11.733c.505 0 .986-.104 1.424-.291C10.737 11.235 9.429 9.773 9.429 8m2.459 2.124.962-1.188 1.417.539-.812-1.3.94-1.205-1.463.386-.836-1.284-.092 1.537-1.458.412 1.407.565z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagTN;
